import { string } from 'yup';

export const passwordValidationSchema = string()
  .required('Password is required')
  .min(8, 'Password must be at least 8 characters.')
  .matches(/\d+/, 'Password must include a number.')
  .matches(/[a-z]/, 'Password must include one lowercase letter.')
  .matches(/[A-Z]/, 'Password must include one uppercase letter.');
